{
  "brand": {
    "name": "nextsub",
    "tagline": "Proxy infrastructure, run like a product."
  },
  "common": {
    "adminNote": {
      "label": "Admin note",
      "hint": "Only visible to admins",
      "placeholder": "Internal context for operators, e.g. upstream contract or cost"
    },
    "actions": {
      "add": "Add",
      "apply": "Apply",
      "archive": "Archive",
      "back": "Back",
      "cancel": "Cancel",
      "clear": "Clear",
      "close": "Close",
      "confirm": "Confirm",
      "continue": "Continue",
      "copy": "Copy",
      "copied": "Copied",
      "create": "Create",
      "delete": "Delete",
      "disable": "Disable",
      "done": "Done",
      "download": "Download",
      "edit": "Edit",
      "enable": "Enable",
      "filter": "Filter",
      "format": "Format",
      "hide": "Hide",
      "loadMore": "Load more",
      "manage": "Manage",
      "more": "More",
      "next": "Next",
      "open": "Open",
      "previous": "Back",
      "publish": "Publish",
      "refresh": "Refresh",
      "remove": "Remove",
      "reset": "Reset",
      "retry": "Try again",
      "revoke": "Revoke",
      "rotate": "Rotate",
      "save": "Save",
      "saveChanges": "Save changes",
      "search": "Search",
      "show": "Show",
      "signIn": "Sign in",
      "signOut": "Sign out",
      "skip": "Skip for now",
      "view": "View",
      "viewAll": "View all",
      "clearSelection": "Clear selection",
      "copyNamed": "Copy {{name}}",
      "showNamed": "Show {{name}}",
      "hideNamed": "Hide {{name}}",
      "dismiss": "Dismiss"
    },
    "labels": {
      "all": "All",
      "any": "Any",
      "created": "Created",
      "description": "Description",
      "details": "Details",
      "email": "Email",
      "expires": "Expires",
      "id": "ID",
      "lastSeen": "Last seen",
      "name": "Name",
      "never": "Never",
      "none": "None",
      "noExpiry": "No expiry",
      "optional": "Optional",
      "status": "Status",
      "unknown": "Unknown",
      "unlimited": "Unlimited",
      "updated": "Updated",
      "you": "You",
      "ip": "IP",
      "assigned": "Assigned",
      "unavailable": "Unavailable"
    },
    "time": {
      "justNow": "Just now",
      "updatedAgo": "Updated {{time}}"
    },
    "units": {
      "nodes_one": "{{count}} node",
      "nodes_other": "{{count}} nodes",
      "users_one": "{{count}} user",
      "users_other": "{{count}} users",
      "members_one": "{{count}} member",
      "members_other": "{{count}} members"
    },
    "search": {
      "placeholder": "Search",
      "noResults": "No matches",
      "optionsLabel": "Search options"
    },
    "copy": {
      "copied": "Copied to clipboard",
      "failed": "Couldn’t copy. Select the text and copy it manually."
    },
    "unsaved": {
      "title": "Discard changes?",
      "body": "Your edits haven’t been saved.",
      "discard": "Discard",
      "keep": "Keep editing",
      "leave": "You have unsaved changes in this panel. Leave the page and discard them?"
    },
    "typedConfirm": "Type {{value}} to confirm",
    "loading": "Loading…",
    "pending": "Working…",
    "showMore": "Show more",
    "showLess": "Show less",
    "rawData": "Raw data",
    "notAvailable": "Not available",
    "staleEdit": {
      "title": "Someone else changed this",
      "body": "Nothing was saved. Close this panel and open it again to edit the latest version.",
      "reload": "Load latest",
      "reloadBody": "Your edits weren’t saved. Load the latest version and apply them again.",
      "reloadFailed": "Couldn’t load the latest version; your edits are kept."
    },
    "inputs": {
      "unit": "Unit",
      "rateNumerator": "Rate numerator",
      "rateDenominator": "Rate denominator",
      "quotaRequired": "Enter a quota (0 or more), or turn on Unlimited."
    },
    "secretGuard": {
      "leave": "A one-time secret is being issued or is still on screen. If you leave now it can’t be shown again. Leave anyway?"
    },
    "json": {
      "invalid": "This isn’t valid JSON.",
      "invalidAt": "This isn’t valid JSON (line {{line}}, column {{column}}).",
      "editorLabel": "JSON editor",
      "plainFallback": "The full editor couldn’t load (the app may have been updated). You can keep editing here."
    },
    "attempt": {
      "unresolvedTitle": "The earlier attempt may have gone through",
      "unresolvedSame": "The response was lost, so it isn't known whether it was created. Submitting the same details again is safe: it replays the first attempt instead of creating a second one.",
      "unresolvedChanged": "Your changes differ from the earlier attempt, which may already have been created. Submitting them could create a second one. Use the original details to retry safely, or start a new one.",
      "maybeExistsTitle": "This probably already exists",
      "maybeExistsBody": "The earlier attempt most likely went through. Check the list before creating another. The details it used are kept below.",
      "retryOriginal": "Use the original details",
      "startNew": "Start a new one",
      "expiredTitle": "The earlier attempt can no longer be retried safely",
      "expiredBody": "It was sent over a day ago, so retrying it now could do it a second time. Check whether it went through, then start a new one if needed."
    },
    "confirmStale": "It changed since you opened this. Close it, review the current version, and try again.",
    "maybeDone": "It may already have happened",
    "maybeDoneBody": "The response was lost. What’s shown has been refreshed: check it before trying again.",
    "notApplied": "It didn’t go through",
    "notAppliedBody": "Checked again: nothing changed. You can try again.",
    "lastUnknown": "The last reset’s response was lost, so it may already have happened. Confirming retries that one (it is never done twice). If it clearly went through (usage or links changed), start a new reset instead.",
    "startNewReset": "Start a new reset instead",
    "openRowHint": "Press Enter or Space to open.",
    "check": {
      "passed": "Passed",
      "failed": "Failed",
      "notChecked": "Not checked",
      "yes": "Yes",
      "no": "No"
    },
    "lastUnknownExpired": "The last one was sent over a day ago and its outcome is unknown, so it can no longer be retried safely. Check whether it went through, then start a new one if needed.",
    "sort": {
      "ascending": ", sorted ascending",
      "descending": ", sorted descending",
      "none": ", not sorted"
    }
  },
  "errors": {
    "validationFailed": "Some fields need attention.",
    "unauthorized": "Your session has ended. Sign in again.",
    "forbidden": "You don’t have permission to do that.",
    "notFound": "We couldn’t find that.",
    "conflict": "This changed while you were editing. Reload and try again.",
    "idempotencyConflict": "This request conflicts with an earlier one.",
    "quotaExceeded": "This would go over the allowed quota.",
    "rateLimited": "Too many requests. Wait a moment and try again.",
    "readinessCheckFailed": "The service isn’t ready yet. Try again shortly.",
    "internalError": "Something went wrong on our side.",
    "networkError": "Can’t reach the server. Check your connection.",
    "requestFailed": "The request didn’t go through.",
    "supportId": "Support ID: {{id}}",
    "retryIn": "Try again in {{seconds}}s",
    "inProgress": "Still processing the previous request. Try again in a moment.",
    "staleTitle": "Someone else changed this",
    "staleBody": "Reload to see the latest version. Your edits are kept until you leave.",
    "staleReload": "Reload latest",
    "referencedBy": "Still used by:",
    "analyticsUnavailable": "Traffic analytics are temporarily unavailable",
    "analyticsUnavailableBody": "Usage and billing are unaffected. Charts come back automatically.",
    "loadFailed": "Couldn’t load this",
    "boundary": "This page hit an unexpected problem.",
    "boundaryAction": "Reload page",
    "references": {
      "subscriptions": "Subscriptions",
      "subscription_package_snapshots": "Subscription history",
      "boot_sessions": "Active adapter sessions",
      "catalog_admin_node_selections": "Tenant node selections",
      "global_node_group_members": "Global node groups",
      "tenant_node_group_members": "Tenant node groups",
      "subscription_link_nodes": "Subscription links",
      "subscription_package_snapshot_nodes": "Subscription history",
      "managed_users": "Users this admin manages",
      "tenant_distribution_packages": "Tenant distribution packages",
      "tenant_admin_role": "The tenant admin role",
      "node_agent_assignments": "Nodes still on this server",
      "package_external_subscriptions": "Packages",
      "subscription_package_snapshot_external_subscriptions": "Subscription history",
      "user_roles": "Roles",
      "user_management_assignments": "Manager assignments",
      "user_credentials": "Node credentials",
      "traffic_routing_policies": "Routing policies",
      "user_routing_policies": "Routing policies",
      "billing_subscription_locks": "Billing in progress",
      "grants": "Grants",
      "referenced_data": "Related records",
      "nodes": "Nodes"
    },
    "conflictInUse": "This {{resource}} is still in use by: {{refs}}.",
    "conflictInUseAny": "This is still in use by: {{refs}}.",
    "conflictResource": "This {{resource}} can’t be changed right now.",
    "conflictGeneric": "This conflicts with existing data.",
    "listSeparator": ", ",
    "resources": {
      "node": "node",
      "package": "package",
      "global_node_group": "node group",
      "external_subscription": "external subscription",
      "adapter_agent": "server",
      "user": "user",
      "user_credential": "credential"
    },
    "nameTaken": "That name is already in use. Choose another.",
    "syncInProgress": "A sync is already running. Try again when it finishes.",
    "staleManifest": "The server's configuration changed in the meantime. Try again; the latest revision will be used.",
    "lastTenantAdmin": "This is the tenant's last active admin. Make another user a tenant admin first, then disable or demote this one.",
    "packageNeedsRefresh": "This plan changed upstream. Refresh it on the Packages page, then assign it again.",
    "reloadLoses": "Reloading will lose work kept on this page: a create whose outcome is unknown (with its generated password or details), unsaved edits or a one-time secret. Reload anyway?"
  },
  "status": {
    "subscription": {
      "pending": "Preparing",
      "pending_binding": "Preparing",
      "active": "Active",
      "paused": "Paused",
      "cancelled": "Cancelled",
      "expired": "Expired",
      "exceeded": "Over quota"
    },
    "node": {
      "pending": "Awaiting install",
      "active": "Active",
      "online": "Online",
      "offline": "Offline",
      "draining": "Draining",
      "disabled": "Disabled"
    },
    "package": {
      "draft": "Draft",
      "active": "Published",
      "archived": "Archived",
      "needsRefresh": "Needs refresh"
    },
    "distributionMode": {
      "managed_only": "Managed",
      "external_only": "External",
      "mixed": "Mixed"
    },
    "link": {
      "active": "Active",
      "expired": "Expired",
      "revoked": "Revoked"
    },
    "token": {
      "active": "Active",
      "revoked": "Revoked",
      "expired": "Expired"
    },
    "user": {
      "active": "Active",
      "disabled": "Disabled"
    },
    "tenant": {
      "active": "Active",
      "disabled": "Disabled"
    },
    "role": {
      "super_admin": "System administrator",
      "tenant_admin": "User administrator",
      "user": "Member"
    },
    "revokeMode": {
      "hard": "Immediate",
      "soft": "Graceful",
      "scheduled": "Scheduled"
    },
    "grantOrigin": {
      "manual": "Manual",
      "subscription": "From subscription"
    },
    "announcement": {
      "draft": "Draft",
      "published": "Published",
      "archived": "Archived",
      "expired": "Expired"
    },
    "policy": {
      "active": "Enabled",
      "disabled": "Disabled"
    },
    "policyScope": {
      "user": "All nodes",
      "user_node": "One node"
    },
    "routeMode": {
      "inherit": "Inherit",
      "overlay": "Add rules",
      "replace": "Replace"
    },
    "resource": {
      "active": "Active",
      "archived": "Archived"
    },
    "sync": {
      "never": "Not synced",
      "success": "Synced",
      "error": "Sync failed"
    },
    "syncError": {
      "fetch_failed": "Couldn’t fetch the source",
      "content_too_large": "Source is too large",
      "invalid_source": "Source refused (bad content, or the address is private)",
      "no_supported_nodes": "No supported nodes found",
      "internal_error": "Internal error"
    },
    "inbound": {
      "ok": "Healthy",
      "stale": "Stale",
      "empty_initial_load": "No users yet",
      "revision_conflict": "Revision conflict",
      "unsupported_protocol": "Unsupported",
      "apply_failed": "Apply failed"
    },
    "manifest": {
      "applied": "Applied",
      "pending": "Waiting to apply",
      "failed": "Apply failed",
      "unknown": "Not reported"
    },
    "preflight": {
      "passed": "Checks passed",
      "failed": "Checks failed",
      "pending": "Waiting for report"
    },
    "outcome": {
      "success": "Succeeded",
      "failure": "Failed",
      "error": "Error",
      "denied": "Denied"
    },
    "capability": {
      "hysteria2": "Supported",
      "anytls": "Supported",
      "shadowsocks_unsupported": "Not supported"
    },
    "credential": {
      "active": "Active",
      "expired": "Expired",
      "revoked": "Revoked",
      "not_yet_valid": "Not yet valid"
    },
    "period": {
      "open": "Open",
      "closed": "Closed"
    },
    "unknown": "Unknown"
  },
  "workspace": {
    "personal": "Personal",
    "tenant": "User management",
    "operator": "Administration",
    "switcher": "Workspace"
  },
  "nav": {
    "sections": {
      "connect": "Connect",
      "account": "Account",
      "manage": "Manage",
      "customers": "Business",
      "infrastructure": "Infrastructure",
      "access": "Access & trust",
      "system": "System"
    },
    "home": "Home",
    "overview": "Overview",
    "subscriptions": "Subscriptions",
    "nodes": "Nodes",
    "usage": "Usage",
    "notifications": "Notifications",
    "account": "Account",
    "users": "Users",
    "packages": "Packages",
    "distributionPackages": "Packages",
    "nodeGroups": "Node groups",
    "tenants": "Tenants",
    "traffic": "Traffic",
    "servers": "Servers",
    "routing": "Routing",
    "externalResources": "External resources",
    "grants": "Grants & denies",
    "credentialDomains": "Credential domains",
    "enrollmentTokens": "Enrollment tokens",
    "announcements": "Announcements",
    "auditLogs": "Audit log"
  },
  "shell": {
    "search": "Search",
    "searchHint": "Search…",
    "notifications": "Notifications",
    "theme": "Appearance",
    "themeSystem": "System",
    "themeLight": "Light",
    "themeDark": "Dark",
    "language": "Language",
    "collapse": "Collapse sidebar",
    "expand": "Expand sidebar",
    "openMenu": "Open menu",
    "signedInAs": "Signed in as",
    "accountSettings": "Account settings",
    "version": "Version {{version}}",
    "webVersion": "Web {{version}}",
    "apiVersion": "API {{version}}",
    "skipToContent": "Skip to content",
    "signedInAsName": "Signed in as {{name}}",
    "signOutLosesTitle": "Sign out and lose unsaved work?",
    "signOutLosesBody": "This page holds something signing out would lose for good: a one-time secret that isn’t saved yet, unsaved edits, or a create whose outcome is unknown (with its generated password or details)."
  },
  "palette": {
    "placeholder": "Search pages, users, servers…",
    "pages": "Pages",
    "actions": "Actions",
    "users": "Users",
    "tenants": "Tenants",
    "nodes": "Nodes",
    "servers": "Servers",
    "empty": "No results",
    "switchTo": "Switch to {{workspace}}",
    "toggleTheme": "Toggle dark mode",
    "switchLanguage": "Switch language",
    "label": "Command menu: search pages, people and actions",
    "searchingAddresses": "Looking up server addresses…",
    "addressLookupFailed": "Couldn’t look up server addresses, so servers weren’t searched by IP.",
    "searchFailed": "Couldn’t search {{what}}; results may be missing.",
    "searching": "Searching…"
  },
  "notifications": {
    "title": "Notifications",
    "empty": "You’re all caught up",
    "markAllRead": "Mark all as read",
    "markRead": "Mark as read",
    "unread_one": "{{count}} unread",
    "unread_other": "{{count}} unread",
    "viewAll": "See all notifications",
    "expires": "Until {{date}}",
    "unreadPrefix": "Unread: ",
    "markReadHint": "Marks this notification as read."
  },
  "auth": {
    "signInTitle": "NextSub Management Console",
    "email": "Email",
    "password": "Password",
    "emailInvalid": "Enter a valid email address.",
    "passwordRequired": "Enter your password.",
    "submit": "Sign in",
    "submitting": "Signing in…",
    "showPassword": "Show password",
    "hidePassword": "Hide password",
    "sessionEnded": "You’ve been signed out. Sign in to continue.",
    "invalidCredentials": "That email and password don’t match. Check them and try again.",
    "accountUnavailable": "Your password was accepted, but this account can’t be opened. It may be disabled. Contact your administrator."
  },
  "forbidden": {
    "title": "This area isn’t available to you",
    "body": "Your account doesn’t have the role this page needs. Switch workspace or go back home.",
    "home": "Go home"
  },
  "notFound": {
    "title": "This page doesn’t exist",
    "body": "The link may be outdated, or the page has moved.",
    "home": "Back to home"
  },
  "public": {
    "nav": {
      "product": "Product",
      "pricing": "Pricing",
      "signIn": "Sign in",
      "openConsole": "Open console"
    },
    "footer": {
      "privacy": "Privacy",
      "terms": "Terms",
      "pricing": "Pricing",
      "rights": "© {{year}} nextsub"
    },
    "landing": {
      "eyebrow": "Proxy control plane",
      "title": "Your proxy fleet.\nOne calm console.",
      "primary": "Sign in",
      "secondary": "See pricing",
      "fleet": {
        "eyebrow": "Infrastructure",
        "title": "Add a server in one command.",
        "body": "Each server gets a one-time install command. Nodes report health, configuration revisions, and traffic back to the panel, so you always know what is actually running.",
        "points": [
          "Hysteria2, AnyTLS and Shadowsocks",
          "Live heartbeat and drift detection",
          "Routing that is checked before it ships"
        ]
      },
      "tenants": {
        "eyebrow": "Reselling",
        "title": "Two levels. Clear boundaries.",
        "body": "Operators grant packages to tenants. Tenants re-package that allowance for their own users, without ever seeing beyond it.",
        "operator": "Operator",
        "operatorBody": "Servers, packages, grants",
        "tenant": "Tenant",
        "tenantBody": "Users, distribution packages",
        "user": "User",
        "userBody": "One link, every client"
      },
      "subscribe": {
        "eyebrow": "Self-service",
        "title": "Scan. Import. Connect.",
        "body": "Users scan a QR code or tap to open Clash, sing-box or Shadowrocket. Quota, usage and node status are always one glance away.",
        "clients": "Works with Clash, sing-box, Shadowrocket and any client that reads URI or Base64 lists."
      },
      "ledger": {
        "title": "Usage you can account for.",
        "body": "Traffic is metered per node with integer rates and written to an append-only ledger. Corrections are new entries, never edits."
      },
      "cta": {
        "title": "Ready when you are.",
        "body": "Accounts are issued by your provider.",
        "action": "Sign in"
      },
      "mock": {
        "fleet": "Fleet",
        "online": "/ {{total}} online",
        "traffic": "Traffic · 7 days",
        "packages": "Packages",
        "tenants": "Tenants",
        "users": "Users"
      }
    },
    "pricing": {
      "title": "Pricing",
      "popular": "Most popular",
      "perMonth": "/month",
      "start": "Get started",
      "contact": "Contact sales",
      "plans": [
        {
          "name": "Professional",
          "price": "$49",
          "description": "For teams running a focused fleet.",
          "features": [
            "Up to 25 nodes",
            "Unlimited tenants",
            "Traffic analytics and rankings",
            "Multiple credential domains",
            "Enrollment tokens",
            "Email support"
          ]
        },
        {
          "name": "Enterprise",
          "price": "Custom",
          "description": "For larger fleets and resellers.",
          "features": ["Unlimited nodes and tenants", "Audit log", "Priority support", "Dedicated onboarding"]
        }
      ],
      "footnote": "Prices exclude tax. Billed in advance."
    },
    "legal": {
      "onThisPage": "On this page"
    }
  },
  "rank": {
    "nodeBoard": "Node leaderboard",
    "userBoard": "User leaderboard",
    "badge": "Daily traffic snapshot",
    "title": "Traffic leaderboard",
    "reportDate": "Report for {{date}}",
    "generatedAt": "Generated {{time}} ({{timezone}})",
    "today": "Daily traffic",
    "last30": "Last 30 days",
    "rawNote": "Raw traffic · not used for billing",
    "users": "Users",
    "nodes": "Nodes",
    "upload": "Up",
    "download": "Down",
    "empty": "No traffic recorded for this day.",
    "snapshotNote": "This is a snapshot saved when the daily report was generated. It doesn’t change with live data, and it contains no internal user or node identifiers.",
    "missing": {
      "title": "Open this from your daily report",
      "body": "Use the “View full leaderboard” link in the Telegram daily report."
    },
    "invalid": {
      "title": "This leaderboard link isn’t valid",
      "body": "Check that the whole link was copied."
    },
    "expired": {
      "title": "This leaderboard has expired",
      "body": "Snapshots are kept for a limited time."
    },
    "failed": {
      "title": "Couldn’t load the leaderboard"
    },
    "boardLabel": "Leaderboard"
  },
  "secret": {
    "onceBody": "Copy these now. For your security they won’t be shown again.",
    "onceBanner": "Shown once. Store it somewhere safe before closing.",
    "expires": "Expires {{date}}",
    "savedConfirm": "I’ve saved this somewhere safe"
  },
  "charts": {
    "download": "Download",
    "upload": "Upload",
    "total": "Total",
    "time": "Time",
    "tableCaption": "Traffic by hour",
    "window": "Time range",
    "windows": {
      "24h": "24 hours",
      "7d": "7 days",
      "30d": "30 days",
      "90d": "90 days"
    },
    "quotaUsage": "{{percent}} used: {{used}} of {{quota}}",
    "unlimitedUsage": "{{used}} used, no quota",
    "updated": "Updated {{time}}",
    "noTraffic": "No traffic in this period",
    "staleFailed": "Couldn’t refresh. Showing earlier data",
    "staleUnavailable": "Analytics is temporarily unavailable. Showing earlier data"
  },
  "me": {
    "home": {
      "morning": "Good morning, {{name}}",
      "afternoon": "Good afternoon, {{name}}",
      "evening": "Good evening, {{name}}",
      "quota": "This period",
      "of": "of {{quota}}",
      "noQuota": "No data cap",
      "periodLabel": "Period {{period}}",
      "nearLimit": "You’ve used most of this period’s data.",
      "overQuota": "You’ve reached this period’s limit. Connections are paused until it resets.",
      "resetTraffic": "Reset usage",
      "resetTitle": "Reset this period’s usage?",
      "resetBody": "Your used data returns to zero for the current period.",
      "resetConsequences": [
        "Your usage history is kept.",
        "Your plan must allow resets; this can’t be undone."
      ],
      "resetDone": "Usage reset",
      "import": "Quick import",
      "noSubscription": "No plan or import link yet",
      "noSubscriptionBody": "Your administrator hasn’t assigned a plan or issued an import link for this account. Once they do, it appears here automatically.",
      "nodes": "Nodes",
      "nodesOnline": "{{online}} of {{total}} online",
      "noNodes": "No nodes available",
      "traffic": "Last 24 hours",
      "latest": "Latest",
      "noNotifications": "No announcements",
      "used": "used",
      "linkInactive": "This link no longer works in your apps. Ask your administrator for a new one.",
      "noActiveLink": "Your plan has no active import link right now. Ask your administrator to issue one."
    },
    "subscriptions": {
      "title": "Subscriptions",
      "defaultName": "My subscription",
      "scan": "Scan to import",
      "scanHint": "Opens in Shadowrocket",
      "copyLink": "Copy link",
      "linkLabel": "Subscription link",
      "customize": "More options",
      "customizeTitle": "Custom link",
      "customizeBody": "Choose a format and address type for clients that need something specific.",
      "format": "Format",
      "formats": {
        "auto": "Automatic",
        "clash": "Clash",
        "singbox": "sing-box",
        "uri": "URI list",
        "base64": "Base64"
      },
      "formatHints": {
        "auto": "The server picks the right format from your client.",
        "clash": "YAML config for Clash and compatible apps.",
        "singbox": "Full sing-box client config.",
        "uri": "One share link per node.",
        "base64": "For v2rayN, Quantumult and similar."
      },
      "family": "Addresses",
      "families": {
        "v4": "IPv4",
        "v6": "IPv6",
        "v4v6": "Both"
      },
      "external": "External nodes",
      "externals": {
        "managed": "Exclude",
        "mixed": "Include",
        "only": "Only"
      },
      "nodeCount_one": "{{count}} node",
      "nodeCount_other": "{{count}} nodes",
      "expires": "Expires {{date}}",
      "noExpiry": "No expiry",
      "resetTitle": "Reset subscription",
      "resetBody": "If your link leaked or you want to revoke old devices, generate a new link. Every client using the old one stops working.",
      "resetAction": "Reset subscription",
      "resetConfirmTitle": "Reset your subscription?",
      "resetConfirmBody": "A new link is generated right away.",
      "resetConsequences": [
        "The current link stops working immediately.",
        "Re-import the new link on every device."
      ],
      "resetDone": "Subscription reset. Import the new link on your devices.",
      "empty": "No active import link",
      "emptyBody": "Ask your administrator to assign a plan or issue an import link for your account.",
      "singBoxUnsupported": "sing-box supports managed Hysteria2, AnyTLS and Shadowsocks nodes. Your plan contains an unsupported node.",
      "singBoxUnchecked": "sing-box is unavailable until your node list loads.",
      "linksUnconfirmed": "A recent change may have replaced these links, so they’re hidden until an up-to-date copy loads (this can take a few seconds).",
      "reloadLinks": "Reload links",
      "qrTooLong": "This link is too long for a QR code. Copy it or use an import button.",
      "singBoxNoNodes": "No nodes are available right now, so the sing-box import is off until one is.",
      "singBoxChecking": "Checking whether your plan can be imported into sing-box…"
    },
    "nodes": {
      "title": "Nodes",
      "online": "Online",
      "offline": "Offline",
      "lastSeen": "Seen {{time}}",
      "neverSeen": "Not seen yet",
      "empty": "No nodes available",
      "emptyBody": "Nodes appear here once your plan includes them.",
      "refreshing": "Refreshes every 30 seconds"
    },
    "usage": {
      "title": "Usage",
      "trend": "Over time",
      "byNode": "By node",
      "topNode": "Most used",
      "windowTotal": "Total in range",
      "noNodeTraffic": "No node traffic in this range.",
      "usedLabel": "Used this period",
      "quotaLabel": "Quota",
      "periodLabel": "Billing period",
      "viewLabel": "Usage view",
      "windowTotalTop": "Total, top {{count}} nodes",
      "rankCapped": "Showing your top {{count}} nodes. Totals and shares cover these nodes only; the Trend view shows your full total.",
      "nodesWithTraffic": "Nodes with traffic"
    },
    "notifications": {
      "truncatedTitle": "Showing the newest notifications",
      "truncatedBody": "Only the newest {{count}} are listed. Older unread ones still count toward your unread total; \"Mark all read\" clears them too."
    },
    "settings": {
      "title": "Account",
      "tabs": {
        "profile": "Profile",
        "security": "Security",
        "appearance": "Appearance",
        "credentials": "Credentials"
      },
      "displayName": "Nickname",
      "email": "Email",
      "userId": "User ID",
      "role": "Role",
      "saveNickname": "Save nickname",
      "nicknameSaved": "Nickname saved",
      "currentPassword": "Current password",
      "newPassword": "New password",
      "confirmPassword": "Confirm new password",
      "passwordMin": "Use at least 12 characters.",
      "passwordMismatch": "Passwords don’t match.",
      "passwordRequired": "Enter your current password.",
      "changePassword": "Change password",
      "signOutNote": "You’ll be signed out after changing your password and can sign in again with the new one.",
      "passwordChanged": "Password changed. Sign in with your new password.",
      "theme": "Appearance",
      "language": "Language",
      "domain": "Credential domain",
      "version": "Version",
      "validFrom": "Valid from",
      "validUntil": "Valid until",
      "noCredentials": "No credentials yet",
      "noCredentialsBody": "Credentials are created when a plan is assigned.",
      "currentPasswordWrong": "That isn’t your current password.",
      "passwordMaybeChanged": "Your new password may already be active",
      "passwordMaybeChangedBody": "The connection dropped, but your session was signed out, which happens when the password changes. Sign in with your new password; if that fails, use the old one.",
      "domainN": "Credential domain {{n}}",
      "passwordSessionChanged": "Password change not confirmed",
      "passwordSessionChangedBody": "You signed in or out in another tab while it was being sent, so it may or may not have gone through. Try signing in with your new password; if that fails, use the old one.",
      "changeLosesTitle": "Change password and lose unsaved work?",
      "changeLosesBody": "Changing your password signs you out. This tab holds a create whose outcome is unknown (with its generated password or details); signing out loses it for good.",
      "changeAnyway": "Change password",
      "passwordUnknown": "Couldn’t confirm the password change",
      "passwordUnknownBody": "The connection dropped and the check failed too, so it may have gone through. You’ve been signed out: sign in with your new password; if that fails, use the old one.",
      "passwordUnconfirmed": "Couldn’t confirm the password change",
      "passwordUnconfirmedBody": "The response was lost and you’re still signed in, so it may not have gone through yet. Don’t retry right away: if you’re signed out shortly, sign in with the new password; otherwise try again in a minute.",
      "passwordHeld": "The last change may already have gone through. If you’re signed out, sign in with the new password. Otherwise, wait a minute and try again.",
      "passwordTryAgain": "Try again"
    }
  },
  "users": {
    "title": "Users",
    "new": "New user",
    "search": "Search name or email",
    "columns": {
      "user": "User",
      "status": "Status",
      "plan": "Plan & usage",
      "expires": "Expires",
      "manager": "Manager",
      "tenant": "Tenant",
      "role": "Role"
    },
    "noPlan": "No plan",
    "direct": "Platform managed",
    "empty": "No users yet",
    "emptyBody": "Create the first account, and optionally assign a plan in the same step.",
    "noMatch": "No users match these filters",
    "filters": {
      "status": "Status",
      "role": "Role",
      "tenant": "Tenant",
      "ownership": "Owner",
      "direct": "Platform managed",
      "managedBy": "Managed by…",
      "managedByName": "Managed by {{name}}",
      "clearManager": "Clear manager filter",
      "selectedAdmin": "the selected admin"
    },
    "create": {
      "title": "New user",
      "email": "Email",
      "displayName": "Name",
      "password": "Password",
      "passwordHint": "At least 12 characters. You’ll see it once after creating.",
      "generate": "Generate",
      "plan": "Plan",
      "planHint": "Optional. Assigns a subscription right away.",
      "noPlan": "Don’t assign yet",
      "tenant": "Tenant",
      "submit": "Create user",
      "created": "User created",
      "secretTitle": "Account created",
      "secretBody": "Share these sign-in details securely. The password isn’t stored anywhere you can read it later.",
      "planFailed": "The user was created, but the plan couldn’t be assigned. Try assigning it again.",
      "planMaybe": "The user was created, but the plan may not have been assigned. Retry to make sure; a plan that was already assigned is not added twice.",
      "retryPlan": "Retry assigning",
      "planAssigned": "Plan assigned",
      "maybeCreatedTitle": "This account may already exist",
      "maybeCreatedSame": "The last attempt didn't get an answer, so the account may have been created. Creating again with the same details finishes that attempt and shows its sign-in details.",
      "maybeCreatedChanged": "The last attempt didn't get an answer, so that account may already exist. These details differ from it; check the user list before creating another account.",
      "displayNameTooLong": "Use 255 characters or fewer.",
      "planSince": "This user has a plan now (assigned since). Use Assign plan to change it; it shows the current plan first."
    },
    "edit": {
      "title": "Edit user",
      "newPassword": "New password",
      "newPasswordHint": "Leave empty to keep the current password.",
      "saved": "Changes saved",
      "emailTaken": "An account already uses this email.",
      "ownPasswordHint": "This is your own account. Change your password in Settings → Security; changing it here would sign you out."
    },
    "actions": {
      "edit": "Edit",
      "enable": "Enable",
      "disable": "Disable",
      "delete": "Delete user",
      "assign": "Assign plan",
      "copyLink": "Copy subscription link",
      "copyPassword": "Copy node password",
      "resetTraffic": "Reset usage",
      "resetSubscription": "Reset subscription",
      "open": "Open details"
    },
    "enabled": "User enabled",
    "disabled": "User disabled",
    "deleted": "User deleted",
    "deleteTitle": "Delete {{name}}?",
    "deleteBody": "This permanently removes the account and cancels its subscription.",
    "deleteConsequences": [
      "Sign-in, roles, credentials, routing and subscription links are removed.",
      "Billing and audit history are kept anonymously.",
      "This can’t be undone."
    ],
    "disableTitle": "Disable {{name}}?",
    "disableBody": "They’re signed out and can’t sign in. Their import links, connection credentials and plan-based node access are revoked now. Enabling the account later restores sign-in only: reset their subscription to give them a new import link.",
    "detail": {
      "tabs": {
        "overview": "Overview",
        "access": "Access",
        "plan": "Plan",
        "links": "Links"
      },
      "joined": "Joined {{date}}",
      "noAccess": "No active subscription",
      "noAccessBody": "Assign a plan to give this user access.",
      "importLinks": "Import links",
      "passwords": "Node passwords",
      "passwordKinds": {
        "node": "Node password",
        "shadowsocks": "Shadowsocks password"
      },
      "currentPlan": "Current plan",
      "period": "Period {{start}} – {{end}}",
      "usage": "Usage this period",
      "resetNeedsActive": "Enable the account to reset its usage or subscription.",
      "linkInactive": "This link no longer works. Issue a new link from Subscriptions.",
      "accessUnconfirmed": "A recent change to this user may have replaced these links and passwords, so they’re hidden until an up-to-date copy loads (this can take a few seconds).",
      "reloadAccess": "Reload access",
      "planUnconfirmed": "A recent change to this user may have replaced their plan, so it’s hidden (and assigning is off) until an up-to-date copy loads.",
      "noActiveLink": "No active import link. Reset the subscription to issue new links.",
      "noPassword": "There's no password to copy for this user right now."
    },
    "resetTrafficTitle": "Reset {{name}}’s usage?",
    "resetTrafficBody": "Usage for the current period returns to zero. History is kept.",
    "resetTrafficDone": "Usage reset",
    "resetSubTitle": "Reset {{name}}’s subscription?",
    "resetSubBody": "New links and node passwords are generated immediately.",
    "resetSubConsequences": [
      "Old links and passwords stop working right away.",
      "The user must re-import on every device."
    ],
    "resetSubDone": "Subscription reset",
    "planUnavailable": "Unavailable",
    "plansFailed": "Plans couldn’t be loaded. Plan and expiry columns are incomplete.",
    "copyPasswordSeveral": "This user has several credentials",
    "copyPasswordSeveralBody": "Open their Access tab and copy the one you need.",
    "openGone": "That user no longer exists"
  },
  "assign": {
    "title": "Assign plan",
    "description": "The user keeps their existing link and passwords; only the nodes change.",
    "plan": "Plan",
    "user": "User",
    "label": "Link label",
    "labelHint": "Optional, to tell links apart.",
    "submit": "Assign",
    "noPlans": "No published plans available",
    "secretTitle": "Plan assigned",
    "secretBody": "Send this import link to the user. It’s always available again in their Access tab.",
    "link": "Import link",
    "secret": "Link secret",
    "loadingLink": "Fetching the import link…",
    "linkMissing": "The new link isn’t listed yet. Open the user’s Access tab in a moment to copy it.",
    "replaces": "Current plan: {{plan}}. Assigning a plan replaces it at once.",
    "replaceTitle": "Replace the current plan?",
    "replaceBody": "{{plan}} ends now, with its current period and quota, and the new plan starts. The user's import links are kept and switch to the new plan.",
    "labelKeptLinks": "This user already has an import link; it's kept, so a label isn't used.",
    "planChanged": "This user's plan changed since you opened this. Review it, then assign again."
  },
  "tenantHome": {
    "title": "Overview",
    "users": "Users",
    "activeUsers": "{{count}} active",
    "subscriptions": "Subscriptions",
    "exceeded": "{{count}} over quota",
    "expiring": "{{count}} expiring in 7 days",
    "allocation": "Your allocation",
    "noAllocation": "No allocation yet",
    "noAllocationBody": "Ask your operator to assign a package with nodes.",
    "maxQuota": "Up to {{quota}} per plan",
    "traffic": "Traffic · 7 days",
    "topUsers": "Top users",
    "attention": "Needs attention",
    "allGood": "Everything looks good",
    "attentionItems": {
      "exceeded": "Subscriptions over quota",
      "refresh": "Plans need a refresh",
      "disabledLinks": "Disabled users with active links"
    },
    "quick": {
      "newUser": "New user",
      "newSubscription": "Assign plan"
    },
    "allocationNodes_other": "{{count}} distributable nodes",
    "allocationNodes_one": "{{count}} distributable node"
  },
  "dpackages": {
    "title": "Packages",
    "new": "New package",
    "allocation": "Allocation",
    "allocationBody": "From {{package}}: {{nodes}} nodes, up to {{quota}} per plan.",
    "unlimitedQuota": "no data cap",
    "noAllocation": "You don’t have an allocation yet",
    "noAllocationBody": "Ask your operator to assign you a package that includes nodes. Then you can create plans here.",
    "empty": "No packages yet",
    "emptyBody": "Create a plan, choose its nodes and quota, then publish it to start assigning.",
    "nodes_one": "{{count}} node",
    "nodes_other": "{{count}} nodes",
    "updated": "Updated {{time}}",
    "needsRefresh": "Your allocation changed. Edit and save this package to drop nodes that are no longer available.",
    "editor": {
      "createTitle": "New package",
      "editTitle": "Edit package",
      "name": "Name",
      "description": "Description",
      "quota": "Data per period",
      "quotaMax": "Can’t exceed your allocation of {{quota}}.",
      "quotaTooHigh": "This is more than your allocation allows.",
      "resetEnabled": "Let users reset usage",
      "resetHint": "Users can reset their usage themselves when close to the limit.",
      "resetUnavailable": "Your allocation doesn’t allow self-service resets.",
      "nodes": "Nodes",
      "nodesRequired": "Choose at least one node.",
      "selectAll": "Select all",
      "selectNone": "Clear",
      "unavailable_one": "{{count}} previously selected node is no longer available and will be removed when you save.",
      "unavailable_other": "{{count}} previously selected nodes are no longer available and will be removed when you save.",
      "saved": "Package saved",
      "created": "Package created as a draft",
      "allocationStale": "Your allocation couldn't be refreshed, so its node list may be out of date. Saving is off until it reloads.",
      "nodesGone": "The nodes you picked are no longer in your allocation. Choose at least one available node.",
      "nodesLeft_one": "{{count}} selected node is no longer in your allocation. Review the nodes and save again.",
      "nodesLeft_other": "{{count}} selected nodes are no longer in your allocation. Review the nodes and save again.",
      "quotaCapChanged": "Your allocation's quota changed, and this package's quota is now above it. Review the quota and save again.",
      "resetChanged": "Traffic reset changed in your allocation. Review it, then save again."
    },
    "actions": {
      "publish": "Publish",
      "apply": "Apply to users",
      "archive": "Archive",
      "delete": "Delete",
      "edit": "Edit"
    },
    "published": "Package published",
    "applied": "Changes applied to current users",
    "archived": "Package archived",
    "deleted": "Package deleted",
    "publishTitle": "Publish {{name}}?",
    "publishBody": "Once published, you can assign it to users.",
    "applyTitle": "Apply changes to current users?",
    "applyBody": "Everyone on {{name}} gets the updated nodes, credentials and subscription content.",
    "applyConsequences": [
      "Users keep their links, but node lists change on next refresh.",
      "Run this after editing a published package."
    ],
    "archiveTitle": "Archive {{name}}?",
    "archiveBody": "It stays on current subscriptions but can’t be assigned anymore.",
    "deleteTitle": "Delete {{name}}?",
    "deleteBody": "Only packages that no active subscription uses can be deleted. Archive it instead if it’s in use.",
    "gone": "This package no longer exists"
  },
  "tsubs": {
    "title": "Subscriptions",
    "tabs": {
      "subscriptions": "Subscriptions",
      "links": "Links"
    },
    "new": "Assign plan",
    "columns": {
      "user": "User",
      "plan": "Plan",
      "status": "Status",
      "usage": "Usage",
      "period": "Period",
      "link": "Link"
    },
    "empty": "No subscriptions yet",
    "emptyBody": "Assign a plan to a user to create their first subscription.",
    "links": {
      "new": "New link",
      "columns": {
        "label": "Label",
        "user": "Subscription",
        "status": "Status",
        "created": "Created",
        "expires": "Expires"
      },
      "empty": "No links yet",
      "emptyBody": "Each subscription gets a link automatically. Create extra links for separate devices.",
      "createTitle": "New link",
      "createBody": "An extra import link for an existing subscription.",
      "subscription": "Subscription",
      "label": "Label",
      "expires": "Expires",
      "expiresHint": "Optional. The link stops working after this time.",
      "editTitle": "Edit link",
      "status": "Status",
      "secretTitle": "Link ready",
      "rotatedTitle": "Secret rotated",
      "rotatedBody": "The old link stopped working. Share the new one from the user’s Access tab.",
      "rotateTitle": "Rotate the secret for {{name}}?",
      "rotateBody": "The current link stops working immediately and a new one is issued.",
      "revokeTitle": "Delete {{name}}?",
      "revokeBody": "This link stops working immediately and can’t be restored.",
      "rotate": "Rotate secret",
      "revoke": "Delete link",
      "deleted": "Link deleted",
      "saved": "Link updated",
      "unnamed": "Unnamed link",
      "createdBody": "The new link is ready. Copy it from the user’s Access tab.",
      "created": "Link created",
      "expiryCannotClear": "An expiry can’t be removed once set. Pick a later date instead.",
      "expireTitle": "Expire {{name}}?",
      "expireBody": "Every device using this link stops connecting as soon as you save. You can make it active again later.",
      "expireConfirm": "Expire link",
      "thisLink": "this link",
      "subsUnavailable": "Subscriptions couldn’t be loaded",
      "subsUnavailableBody": "Owners can’t be shown and new links can’t be created until they load.",
      "expiryMustBeFuture": "This link’s expiry has passed. Set a future expiry to make it work again.",
      "maybeDone": "It may already have gone through",
      "maybeDoneBody": "The response was lost. The link list has been refreshed: check it before trying again."
    }
  },
  "tgroups": {
    "title": "Node groups",
    "new": "New group",
    "name": "Group name",
    "empty": "No node groups yet",
    "emptyBody": "Group nodes to keep them organized.",
    "manage": "Choose nodes",
    "manageTitle": "Nodes in {{name}}",
    "manageBody": "Pick from nodes your operator has granted to you. Saving replaces the group’s nodes.",
    "noNodes": "No nodes have been granted to you yet.",
    "saved": "Nodes updated",
    "created": "Group created",
    "deleted": "Group deleted",
    "deleteTitle": "Delete {{name}}?",
    "deleteBody": "The group and its node selection are removed. This can’t be undone.",
    "members_one": "{{count}} node",
    "members_other": "{{count}} nodes",
    "unavailableTitle_one": "{{count}} member is no longer available",
    "unavailableTitle_other": "{{count}} members are no longer available",
    "unavailableBody": "Their grant was revoked or they were denied. Saving removes them from this group.",
    "nodesUnavailable": "Node names couldn’t be loaded",
    "nodesUnavailableBody": "Members are shown without names until the node list loads.",
    "unknownNode": "Unknown node",
    "nodesLeft_one": "{{count}} selected node is no longer available to you. Review the list and save again.",
    "nodesLeft_other": "{{count}} selected nodes are no longer available to you. Review the list and save again."
  },
  "tusage": {
    "title": "Usage",
    "tabs": {
      "traffic": "Traffic",
      "billable": "Billable usage"
    },
    "topUsers": "Top users",
    "topNodes": "Top nodes",
    "columns": {
      "subscription": "Subscription",
      "meter": "Meter",
      "total": "Total",
      "window": "Measured",
      "updated": "Updated"
    },
    "filters": {
      "subscription": "Subscription",
      "period": "Period"
    },
    "empty": "No usage recorded yet",
    "emptyBody": "Usage appears once users start connecting.",
    "meters": {
      "adapter_traffic": "Data transfer",
      "other": "Other meter ({{name}})"
    },
    "subsFailed": "Subscriptions couldn’t be loaded. Rows can’t be matched to users, and the subscription filter is unavailable."
  },
  "opHome": {
    "title": "Overview",
    "userCount": "Users",
    "monthlyTraffic": "Traffic this month",
    "fleet": "Fleet",
    "nodesOnline": "{{online}} of {{total}} nodes online",
    "serversOnline": "{{online}} of {{total}} servers online",
    "online": "Online",
    "attentionNodes": "Needs attention",
    "offline": "Offline",
    "attention": "Needs attention",
    "attentionItems": {
      "pendingServers": "Servers waiting for install",
      "applyFailed": "Servers with failed config apply",
      "driftNodes": "Nodes with config drift",
      "offlineNodes": "Active nodes offline",
      "refreshPackages": "Packages that need a refresh",
      "syncErrors": "External subscriptions failing to sync"
    },
    "traffic": "Traffic · 7 days",
    "topTenants": "Top tenants",
    "recentActivity": "Recent activity",
    "noActivity": "No recent activity",
    "announcements": "Announcements",
    "publishedCount_one": "{{count}} published",
    "publishedCount_other": "{{count}} published",
    "newAnnouncement": "New announcement",
    "customers": "Customers",
    "tenantsCount_one": "{{count}} tenant",
    "tenantsCount_other": "{{count}} tenants",
    "announcementsUnavailable": "Announcements unavailable",
    "noActivityScanned": "No operator activity in the latest {{count}} log entries. Open the audit log to look further back.",
    "topUsers": "Leaderboard"
  },
  "tenants": {
    "title": "Tenants",
    "new": "New tenant",
    "search": "Search name or slug",
    "columns": {
      "tenant": "Tenant",
      "status": "Status",
      "created": "Created"
    },
    "empty": "No tenants yet",
    "emptyBody": "Onboard a tenant to give a reseller their own space and admin account.",
    "wizard": {
      "title": "New tenant",
      "steps": ["Tenant", "Administrator", "Review"],
      "name": "Tenant name",
      "slug": "URL slug",
      "slugHint": "Lowercase letters, numbers and hyphens.",
      "slugInvalid": "Use lowercase letters, numbers and hyphens only.",
      "adminEmail": "Admin email",
      "adminName": "Admin name",
      "adminPassword": "Admin password",
      "review": "Check the details before creating. The tenant and its first admin are created together.",
      "submit": "Create tenant",
      "secretTitle": "Tenant created",
      "secretBody": "Share these sign-in details with the tenant’s administrator.",
      "maybeCreatedTitle": "This tenant may already exist",
      "maybeCreatedBody": "The last attempt didn't get a response. Submitting the same details again finishes it and shows the admin's sign-in details; changing them starts a new tenant.",
      "slugNeeded": "Enter a URL slug: this name can’t be turned into one.",
      "emailTaken": "This email is already used by another account.",
      "nameTooLong": "This is too long (255 characters at most)."
    },
    "detail": {
      "tabs": {
        "users": "Users",
        "subscriptions": "Subscriptions",
        "packages": "Assignable packages",
        "grants": "Grants",
        "traffic": "Traffic",
        "routing": "Routing"
      },
      "back": "Tenants",
      "edit": "Edit tenant",
      "disable": "Disable tenant",
      "disableTitle": "Disable {{name}}?",
      "disableBody": "Every user in this tenant loses access.",
      "disableConsequences": [
        "Users can’t sign in or connect.",
        "Tenants can’t be re-enabled from the panel; contact engineering to restore."
      ],
      "disabled": "Tenant disabled",
      "saved": "Tenant updated",
      "cancelSubscription": "Cancel subscription",
      "cancelTitle": "Cancel this subscription?",
      "cancelBody": "The user loses access at once. This can’t be undone.",
      "cancelled": "Subscription cancelled",
      "noPackages": "No packages can be assigned to this tenant yet.",
      "policies": "Routing policies",
      "noPolicies": "No user routing policies in this tenant.",
      "newGrant": "New grant",
      "slugTaken": "That URL slug is already used by another tenant.",
      "disableOwn": "This is your own tenant. Disabling it would sign you and every operator in it out, and it can't be re-enabled from the panel.",
      "cancelTitleNamed": "Cancel {{name}}’s subscription?",
      "cancelBodyNamed": "{{plan}} ends now and the user loses access at once. This can’t be undone."
    }
  },
  "opUsers": {
    "promote": "Make tenant…",
    "promoteTitle": "Make {{name}} a tenant?",
    "promoteBody": "Creates a new tenant and moves this user into it as its administrator.",
    "promoteConsequences": ["The user leaves their current tenant.", "This can’t be undone from the panel."],
    "promoteDone": "Tenant created",
    "setManager": "Change manager…",
    "managerTitle": "Manager for {{name}}",
    "managerBody": "Assign a user administrator or let the platform manage this account directly.",
    "managerNone": "Platform managed",
    "managerSaved": "Manager updated",
    "makeAdmin": "Make user administrator",
    "revokeAdmin": "Remove user administrator",
    "roleSaved": "Role updated",
    "viewManaged": "Show users they manage",
    "tenantSettings": "Open tenant",
    "loadedCount": "{{count}} loaded",
    "revokeTitle": "Remove {{name}} as a user administrator?",
    "revokeBody": "Their account remains, but they lose access to user management.",
    "revokeConsequences": [
      "They can no longer manage users, plans, or subscriptions within their authorized scope.",
      "Reassign the users they manage to another administrator first.",
      "At least one active administrator must remain within each management scope."
    ],
    "openNotFound": "User not found",
    "openNotFoundBody": "They may not exist or may not match the current filters.",
    "managerLabel": "Managed by",
    "promoteNameRequired": "Enter a tenant name.",
    "promoteOtherTenant": "Only users in your own tenant can be promoted.",
    "grantAdminTitle": "Make {{name}} a user administrator?",
    "grantAdminBody": "They will gain user management permissions within their authorized scope.",
    "grantAdminConsequences": [
      "Can create and manage users, plans, and subscriptions within their authorized scope.",
      "Can view usage and traffic within their authorized scope."
    ],
    "managerInactive": "Disabled — pick an active admin",
    "openNotLoaded": "Still looking for this user",
    "openNotLoadedBody": "They aren't in the pages loaded so far. Load more, or search by email."
  },
  "opPackages": {
    "title": "Packages",
    "new": "New package",
    "empty": "No packages yet",
    "emptyBody": "Create a package from node groups or external subscriptions, then publish it.",
    "cycle": {
      "monthly": "Monthly",
      "quarterly": "Quarterly",
      "yearly": "Yearly"
    },
    "perCycle": "{{quota}} / {{cycle}}",
    "editor": {
      "createTitle": "New package",
      "editTitle": "Edit package",
      "steps": ["Basics", "Sources", "Review"],
      "name": "Name",
      "description": "Description",
      "quota": "Data per period",
      "cycle": "Resets",
      "resetEnabled": "Allow self-service usage reset",
      "managed": "Managed node groups",
      "external": "External subscriptions",
      "directWarning": "External nodes are distributed directly and skip your managed install and health checks.",
      "sourcesRequired": "Choose at least one node group or external subscription.",
      "noGroups": "No node groups yet.",
      "noExternal": "No external subscriptions yet.",
      "saved": "Package saved",
      "created": "Package created as a draft",
      "conflictTitle": "Someone else changed this package",
      "conflictBody": "Your edits are still here but weren’t saved. Load the latest version to start again from it.",
      "conflictReload": "Load latest"
    },
    "publishTitle": "Publish {{name}}?",
    "publishBody": "Once published, this plan can be assigned to users.",
    "checks": "Pre-publish checks",
    "checkItems": {
      "sources_present": "Has at least one source",
      "node_groups_present": "Node groups are present",
      "external_subscriptions_ready": "External subscriptions are synced",
      "unique_nodes": "No duplicate nodes",
      "credentials_ready": "Credentials can be issued",
      "export_ready": "Subscription export works",
      "direct_distribution": "Uses direct distribution"
    },
    "published": "Package published",
    "archiveTitle": "Archive {{name}}?",
    "archiveBody": "Existing subscriptions keep it; it can’t be assigned anymore.",
    "archived": "Package archived",
    "deleteTitle": "Delete {{name}}?",
    "deleteBody": "Permanently deletes the package. Packages still used by subscriptions can’t be deleted.",
    "deleted": "Package deleted",
    "sources_one": "{{count}} source",
    "sources_other": "{{count}} sources",
    "gone": "This package no longer exists"
  },
  "opTraffic": {
    "title": "Traffic",
    "billingUsage": "Current billing usage",
    "billingPeriod": "Billing period: {{period}} · independent of the chart's time range",
    "openUser": "Open user details",
    "usageNeedsTenant": "Open the user details to view their current billing usage.",
    "usageUnavailable": "Billing usage is not available for this subscription yet.",
    "noSubscription": "This user has no current subscription.",
    "filters": {
      "tenant": "Tenant"
    },
    "rankings": "Top consumers",
    "dimensions": {
      "tenant": "Tenants",
      "user": "Users",
      "node": "Nodes"
    },
    "clearFilter": "Clear {{dimension}} filter: {{name}}",
    "selectedUser": "Selected user",
    "selectedNode": "Selected node"
  },
  "grants": {
    "title": "Grants & denies",
    "tabs": {
      "grants": "Grants",
      "denies": "Denies"
    },
    "new": "New grant",
    "columns": {
      "node": "Node",
      "tenant": "Tenant",
      "mode": "Revocation",
      "origin": "Origin",
      "created": "Created"
    },
    "filters": {
      "tenant": "Tenant",
      "node": "Node",
      "revoked": "Include revoked"
    },
    "empty": "No grants",
    "emptyBody": "Grants are created automatically from subscriptions, or manually here.",
    "fromSubscription": "Managed by a subscription. Change it through the package or subscription instead.",
    "form": {
      "createTitle": "New grant",
      "editTitle": "Edit grant",
      "node": "Node",
      "tenant": "Tenant",
      "grantedBy": "Note",
      "grantedByHint": "Who approved it or why, for the audit trail.",
      "mode": "When revoked",
      "modes": {
        "hard": "Cut access immediately.",
        "soft": "Let existing sessions finish before cutting access.",
        "scheduled": "Revoke automatically at a set time."
      },
      "revokeAt": "Revoke at",
      "revokeAtRequired": "Choose when to revoke."
    },
    "saved": "Grant saved",
    "revokeTitle": "Revoke this grant?",
    "revokeBody": "{{tenant}} loses access to {{node}} according to its revocation mode.",
    "revoked": "Grant revoked",
    "deny": {
      "new": "New deny",
      "notice": "Denies are stored and enforced, but the API can’t list them. Only denies created on this page during this visit are shown below, so you can correct them.",
      "empty": "No denies created this visit",
      "emptyBody": "Create a deny to block a tenant from a node during an incident.",
      "createTitle": "New deny",
      "editTitle": "Edit deny",
      "reason": "Reason",
      "reasonRequired": "Explain why access is denied.",
      "startsAt": "Starts",
      "endsAt": "Ends",
      "windowHint": "Leave empty for no limit.",
      "saved": "Deny saved",
      "deleteTitle": "Remove this deny?",
      "deleteBody": "{{tenant}} regains access to {{node}} if otherwise granted.",
      "deleted": "Deny removed",
      "justNow": "Created this visit",
      "window": "{{from}} → {{to}}",
      "open": "open",
      "leave": "Denies you created here can't be listed again once you leave this page. They stay in force. Leave anyway?",
      "endBeforeStart": "The end must be after the start.",
      "confirmTitle": "Block {{tenant}} on {{node}}?",
      "confirmBody": "The tenant's users lose access to this node {{window}}. Existing grants stay, but they can't connect while the deny is in effect.",
      "confirmCreate": "Create deny",
      "windowNow": "now",
      "windowUntilRemoved": "until the deny is removed",
      "windowRange": "from {{from}}, {{until}}",
      "windowUntil": "until {{at}}",
      "removalUnconfirmed": "Removal unconfirmed: it may already be lifted. Remove again to make sure.",
      "gone": "This deny no longer exists",
      "goneBody": "It was already removed (perhaps by an earlier removal whose response was lost).",
      "editUnconfirmed": "Edit unconfirmed: showing the values you saved, which may not have been applied. Saving them again is safe (it replaces the whole deny)."
    },
    "viewLabel": "Show",
    "schedule": {
      "action": "Schedule revocation…",
      "title": "Schedule revocation",
      "submit": "Schedule revocation",
      "mustBeFuture": "Choose a time in the future.",
      "confirmTitle": "Schedule this revocation?",
      "confirmBody": "{{tenant}} loses access to {{node}} at {{when}}.",
      "saved": "Revocation scheduled",
      "alreadyRevoked": "This grant has already been revoked, so there's nothing to schedule."
    },
    "revokeBodyNow": "{{tenant}} loses access to {{node}} immediately. Connected sessions are cut off.",
    "revokeBodySoft": "{{tenant}} loses access to {{node}} now; sessions already connected are allowed to finish (graceful revoke).",
    "revokesAt": "Revokes {{time}}",
    "revokedAt": "Revoked {{time}}",
    "alreadyRevoked": "This grant has already been revoked.",
    "otherTenantAttempt": "That unfinished grant is for another tenant. Finish it from that tenant's page or the Grants page."
  },
  "domains": {
    "title": "Credential domains",
    "new": "New domain",
    "name": "Name",
    "nameHint": "Lowercase identifier, e.g. default or premium.",
    "description": "Description",
    "empty": "No credential domains yet",
    "emptyBody": "Node group members reference a domain to decide which credentials users get.",
    "created": "Domain created",
    "note": "Domains can’t be renamed or removed after creation.",
    "nameInvalid": "Use lowercase letters, digits, - or _, starting with a letter or digit."
  },
  "enroll": {
    "title": "Enrollment tokens",
    "issue": "Issue token",
    "expires": "Expires",
    "expiresRequired": "Choose an expiry time.",
    "node": "Bind to node",
    "issued": "Token issued",
    "secretTitle": "Enrollment token",
    "check": "Check a token",
    "token": "Token",
    "verify": "Verify",
    "consume": "Consume",
    "consumeTitle": "Consume this token?",
    "consumeBody": "It’s marked as used and can’t enroll anything else.",
    "result": "Result",
    "valid": "Token is valid",
    "consumed": "Token consumed",
    "singleUse": "Single use",
    "multiUse": "Reusable",
    "usedAt": "Used",
    "notUsed": "Not used yet",
    "expiresPast": "Choose a time in the future.",
    "usage": "Use",
    "rejectedExpired": "This token has expired. Issue a new one.",
    "rejectedUsed": "This token was already used. Single-use tokens work once.",
    "issueUnknownTitle": "A token may have been issued",
    "issueUnknownBody": "The response was lost, so its secret can’t be shown, and tokens can’t be listed or revoked here. If it was issued it stays valid until {{expires}}. Issue another only once you’ve accounted for that.",
    "issueUnknownAck": "Understood",
    "consumeUnknown": "The token may already be used",
    "consumeUnknownBody": "The response was lost after the request was sent. Consuming it again replays the same request and shows how it went."
  },
  "ann": {
    "title": "Announcements",
    "new": "New announcement",
    "empty": "No announcements",
    "emptyBody": "Announcements appear in users’ notifications.",
    "audience": "Audience",
    "everyone": "Everyone",
    "published": "Published {{time}}",
    "draft": "Draft · updated {{time}}",
    "expires": "Until {{date}}",
    "form": {
      "createTitle": "New announcement",
      "editTitle": "Edit announcement",
      "title": "Title",
      "body": "Message",
      "audience": "Audience",
      "tenant": "Tenant",
      "expires": "Show until",
      "expiresHint": "Optional. Hidden from users after this time.",
      "publishNow": "Publish now",
      "preview": "Preview",
      "expiresPast": "This time has passed. An expired announcement is hidden from everyone; pick a future time or leave it empty."
    },
    "actions": {
      "publish": "Publish",
      "republish": "Publish again",
      "archive": "Archive",
      "delete": "Delete",
      "edit": "Edit"
    },
    "saved": "Announcement saved",
    "publishedToast": "Announcement published",
    "archived": "Announcement archived",
    "deleted": "Announcement deleted",
    "deleteTitle": "Delete “{{title}}”?",
    "deleteBody": "This can’t be undone.",
    "archiveTitle": "Archive “{{title}}”?",
    "archiveBody": "Users stop seeing it. You can publish it again later.",
    "cantDelete": "Archive a published announcement before deleting it.",
    "publishTitle": "Publish “{{title}}”?",
    "publishBodyAll": "Every user sees it in their notifications right away.",
    "publishExpired": "Its expiry has passed, so nobody would see it. Edit the expiry first.",
    "gone": "This announcement no longer exists",
    "publishBodyTenantNamed": "Every user in {{tenant}} sees it in their notifications right away.",
    "emptyFiltered": "No announcements with this status",
    "showAll": "Show all"
  },
  "servers": {
    "title": "Servers",
    "new": "Add server",
    "empty": "No servers yet",
    "emptyBody": "Add a server to get a one-time install command for the host.",
    "nodes_one": "{{count}} node",
    "nodes_other": "{{count}} nodes",
    "never": "Never seen",
    "seen": "Seen {{time}}",
    "manifest": "Config revision {{applied}} of {{latest}}",
    "applied": "Config applied",
    "pendingApply": "Waiting to apply revision {{rev}}",
    "applyFailed": "Config apply failed",
    "state": {
      "online": "Online",
      "offline": "Offline",
      "pending": "Awaiting install",
      "draining": "Draining",
      "disabled": "Disabled",
      "attention": "Needs attention",
      "unknown": "Status unknown"
    },
    "actions": {
      "open": "Open",
      "edit": "Edit",
      "reissue": "Reissue install command",
      "enable": "Enable",
      "disable": "Disable",
      "delete": "Delete server",
      "installCommands": "Nodes and install commands"
    },
    "edit": {
      "title": "Edit server",
      "name": "Name",
      "status": "Status",
      "metadata": "Labels",
      "metadataHint": "JSON object, e.g. {\"region\":\"JP\"}. Used for naming and filtering.",
      "metadataInvalid": "Enter a valid JSON object.",
      "saved": "Server saved"
    },
    "wizard": {
      "title": "Add server",
      "steps": ["Details", "First node", "Install", "Connect"],
      "name": "Server name",
      "nameHint": "e.g. tokyo-01. If you set region, provider or route labels, the server is listed by those labels instead.",
      "region": "Region label",
      "regionHint": "Optional, e.g. JP or US-West.",
      "installTitle": "Run this on the host",
      "installBody": "Paste the command on the server as root. It installs the adapter for this node only; add more nodes later from the server page, each with its own install command.",
      "command": "Install command",
      "token": "Agent token",
      "script": "Install script",
      "showScript": "Show full script",
      "ran": "I’ve run it",
      "waiting": "Waiting for the node to connect…",
      "waitingBody": "This updates automatically. Installation usually takes under a minute.",
      "connected": "Node connected",
      "preflight": "Preflight checks",
      "skipWait": "Finish later",
      "firstNode": "Add the server's first node",
      "done": "Server added",
      "backToInstall": "Show install command again",
      "alreadyCreatedTitle": "This server was already created",
      "alreadyCreatedBody": "An earlier attempt created it, but its one-time install command can't be shown again. Close this and reissue the install command from the server's menu.",
      "alreadyCreatedAction": "Go to servers",
      "addFirstNode": "Add first node",
      "issuing": "Getting the install command…",
      "issueFailedTitle": "The node was created, but its install command couldn't be fetched",
      "issueRetry": "Get install command",
      "openServer": "Open server",
      "attemptKeptTitle": "An earlier attempt may have created this server",
      "attemptKeptBody": "The details below are the ones you submitted. Continue to finish that attempt instead of creating a second server.",
      "startNew": "Start a new server",
      "retryOriginal": "Use the original details",
      "attemptChangedBody": "These details differ from the earlier attempt, which may already have created a server. Submitting different values could create a second one: use the original details to finish that attempt, or start a new server on purpose."
    },
    "deleteTitle": "Delete {{name}}?",
    "deleteBody": "Removes the server record and every node assigned to it.",
    "deleted": "Server deleted",
    "uninstallTitle": "Clean up the host",
    "uninstallBody": "Deleting the server didn’t touch the machine. Run this on the host to stop every node adapter it runs and remove the adapter files.",
    "uninstallOneLine": "One line",
    "uninstallScript": "Step by step",
    "reissuedTitle": "New install command",
    "saved": "Server saved",
    "toggled": "Server updated",
    "disable": {
      "title": "Disable {{name}}?",
      "body": "The server is taken out of service in the panel.",
      "noReissue": "Its install command can’t be reissued and no new nodes can be added to it.",
      "hasNodes_one": "It still runs {{count}} node. Move or remove it first; a server with nodes can’t be disabled.",
      "hasNodes_other": "It still runs {{count}} nodes. Move or remove them first; a server with nodes can’t be disabled.",
      "reenable": "You can enable it again at any time.",
      "unknownNodes": "Assigned nodes couldn’t be checked yet. A server that still runs nodes can’t be disabled, so this stays off until they load.",
      "manifestPending": "This server's latest configuration hasn't been applied yet",
      "manifestPendingBody": "It can't be disabled until the server applies its latest configuration. If it no longer reports in, delete it instead."
    },
    "uninstallFormat": "Command format",
    "deleteUnknownCount": "Every node assigned to this server is deleted. The node count couldn’t be loaded.",
    "alreadyInState": "The server was already in that state. Nothing changed.",
    "reissueNeedsEnabled": "Enable the server first to issue a new install command.",
    "uninstallLegacy": "Legacy agent-mode install",
    "uninstallLegacyBody": "This server also reported an agent-mode install. If that daemon is still on the host, remove it too.",
    "nodesOnline": "{{online}} of {{total}} nodes online",
    "uninstallCommandLabel": "Cleanup command",
    "uninstallLegacyLabel": "Legacy agent-mode cleanup",
    "deleteLeave": "The server is being deleted, or its host cleanup commands are still on screen. If you leave now they won’t be shown again. Leave anyway?",
    "uninstallUnconfirmed": "The delete’s response was lost and it couldn’t be confirmed. Run these only after checking that it no longer appears in the list: running them on a live host stops its nodes.",
    "nameTooLong": "This name is too long (255 bytes at most; Chinese characters count as 3).",
    "deleteConsequences_other": [
      "{{count}} assigned nodes are deleted.",
      "Users lose these nodes on their next refresh.",
      "The host keeps running until you uninstall it."
    ],
    "deleteConsequences_one": [
      "{{count}} assigned node is deleted.",
      "Users lose these nodes on their next refresh.",
      "The host keeps running until you uninstall it."
    ],
    "labelsReplaceName": "While region, provider or route labels are set, the server is listed by those labels, not this name.",
    "sharedRelay": {
      "add": "Add relay entrance",
      "label": "Relay server",
      "saved": "Relay entrance added",
      "sharedBackend": "Shares existing backend",
      "configured": "Entrance configured",
      "backend": "Backend server",
      "group": "Package node group",
      "address": "Public IPv4 / hostname",
      "port": "Public port",
      "accounting": "Credentials and usage",
      "accountingBody": "Uses each user’s backend credentials and quota. Usage is recorded against the linked backend node. Entrances sharing a node are counted together; separate line accounting requires dedicated backend nodes and listeners."
    },
    "columns": {
      "name": "Name",
      "state": "Status",
      "address": "IPv4",
      "created": "Created"
    }
  },
  "serverDetail": {
    "back": "Servers",
    "tabs": {
      "overview": "Overview",
      "nodes": "Nodes",
      "tokens": "Tokens"
    },
    "status": "Status",
    "addresses": "Addresses",
    "version": "Adapter",
    "fingerprint": "Fingerprint",
    "installed": "Installed",
    "lastSeen": "Last seen",
    "created": "Created",
    "configuration": "Configuration",
    "revisionApplied": "Revision {{rev}} applied",
    "revisionPending": "Revision {{applied}} applied · {{latest}} pending",
    "applyError": "Apply error",
    "preflight": "Preflight",
    "preflightChecked": "Checked {{time}}",
    "preflightNotReported": "The server hasn’t reported preflight checks yet.",
    "checks": {
      "ports": "Ports available",
      "system": "Supported system",
      "time_sync": "Clock in sync",
      "certificate": "Certificates trusted",
      "outbound_network": "Can reach the panel",
      "permissions": "Permissions",
      "capabilities": "Capabilities"
    },
    "nodes": {
      "new": "New node",
      "newDisabled": "Enable this server to add nodes.",
      "empty": "No nodes on this server",
      "emptyBody": "Create a node to start serving users from this host.",
      "unassign": "Remove from server",
      "unassignTitle": "Remove {{name}} from this server?",
      "unassignBody": "The node stops receiving configuration from this server. The node itself isn’t deleted.",
      "unassigned": "Node removed from server",
      "move": "Move to another server…",
      "moveTitle": "Move {{name}}",
      "moveBody": "Moving reassigns the node in the panel only. Its adapter keeps running on this host until you remove it, and the target host needs the node's install command. Both steps are shown after the move.",
      "target": "Target server",
      "moved": "Node moved",
      "createTitle": "New node",
      "protocol": "Protocol",
      "port": "Port",
      "portHint": "Leave empty for the protocol default.",
      "nodeName": "Name",
      "nodeNameHint": "Suggested from the protocol and server.",
      "ssMethod": "Encryption",
      "created": "Node created",
      "targetUnavailable": "Can’t receive nodes ({{status}})",
      "moveNeedsActive": "Only active or pending nodes can move.",
      "resumedAttempt": "Your last attempt to create this node may already have succeeded. Creating it again with these values replays that attempt instead of adding a second node.",
      "installCommand": "Install command",
      "attemptChanged": "An earlier attempt may already have created this node. These values differ from it, so creating now could add a second node. Use the original values to finish that attempt, or start a new node on purpose.",
      "retryOriginal": "Use the original values",
      "startNew": "Start a new node",
      "leaveDuringChange": "A node change is in progress or its follow-up steps are on screen. If you leave now, the cleanup and install commands won’t be shown again. Leave anyway?",
      "moveInstallFailed": "{{name}} moved, but its install command for the new server couldn’t be fetched. Get it now, or later from that server’s Nodes tab.",
      "openTarget": "Open new server",
      "changeUnconfirmed": "Couldn’t confirm whether the change to {{name}} went through. Check again before leaving: if it did, its host needs cleanup.",
      "checkAgain": "Check again",
      "movedElsewhere": "This node is no longer on the server it was moved to. Install it from the server it's on now.",
      "movedElsewhereBody": "Someone may have moved it meanwhile. Its adapter still runs on this host: the cleanup command follows.",
      "moveChecking": "The response was lost. Checking whether the move went through…",
      "finishChangeFirst": "Finish the current node change first",
      "targetUnconfirmed": "{{name}} has left this server, but couldn’t be confirmed on its new server yet. Check again to get its install command.",
      "movedElsewhereShown": "Its cleanup command for this host was shown earlier.",
      "targetGone": "{{name}}’s new server no longer exists",
      "targetGoneBody": "The node left this server, but its target server was deleted. Its adapter still runs on this host: the cleanup command follows.",
      "notOnTarget": "{{name}} isn't on the server it was moved to",
      "installMovedOff": "{{name}} is no longer on this server. Install it from wherever it is now, if anywhere."
    },
    "tokens": {
      "new": "New token",
      "label": "Label",
      "prefix": "Prefix",
      "expires": "Expires",
      "lastUsed": "Last used",
      "empty": "No tokens",
      "rotate": "Rotate",
      "revoke": "Revoke",
      "delete": "Delete",
      "rotateTitle": "Rotate {{name}}?",
      "rotateBody": "A new token is issued. The old one keeps working for a short grace period.",
      "revokeTitle": "Revoke {{name}}?",
      "revokeBody": "The server can’t authenticate with this token anymore.",
      "deleteTitle": "Delete {{name}}?",
      "deleteBody": "Permanently removes this revoked token.",
      "secretTitle": "Agent token",
      "createdBody": "Copy it now; it isn’t shown again. A node adapter on this server can use it as its token. To install a node, use that node’s Install command on the Nodes tab.",
      "revoked": "Token revoked",
      "deleted": "Token deleted",
      "unnamed": "Untitled token",
      "rotateUnknown": "The rotation may have gone through",
      "rotateUnknownBody": "If it did, the old token is already revoked and the new one can’t be shown again. Check the token list; if the old token shows as revoked, create a new token and update the host.",
      "agentRotateUnknownBody": "If it did, a replacement token now appears in the list and its secret can’t be shown again; the old token stays valid for its grace period. Revoke that replacement and create a new token instead of rotating again.",
      "issueUnknown": "A new token may have been issued",
      "issueUnknownBody": "The response was lost, so its secret can’t be shown. Check the token list and revoke any token you don’t recognise, then try again.",
      "createdExpires": "created {{created}} · expires {{expires}}",
      "createdNoExpiry": "created {{created}} · no expiry",
      "labelTooLong": "This label is too long (255 bytes at most; Chinese characters count as 3)."
    },
    "nodeHealth": {
      "title": "Nodes on this server",
      "none": "No nodes yet. Add one from the Nodes tab.",
      "online": "Online",
      "pending": "Awaiting install",
      "offline": "Offline or needs attention",
      "drift": "Config drift",
      "disabled": "Disabled"
    }
  },
  "nodes": {
    "title": "Nodes",
    "new": "New standalone node",
    "search": "Search name or address",
    "columns": {
      "node": "Node",
      "server": "Server",
      "address": "IP",
      "health": "Health",
      "config": "Config",
      "version": "Adapter",
      "seen": "Last seen"
    },
    "filters": {
      "protocol": "Protocol",
      "health": "Health",
      "server": "Server",
      "drift": "Config drift"
    },
    "health": {
      "online": "Online",
      "attention": "Needs attention",
      "offline": "Offline",
      "pending": "Not installed",
      "disabled": "Disabled"
    },
    "drift": "Drift",
    "noServer": "Standalone",
    "empty": "No nodes yet",
    "emptyBody": "Nodes are created from a server, or as standalone nodes with their own install command.",
    "detail": {
      "tabs": {
        "overview": "Overview",
        "tokens": "Adapter tokens"
      },
      "inbounds": "Inbounds",
      "users_one": "{{count}} user",
      "users_other": "{{count}} users",
      "runtime": "Runtime",
      "uptime": "Uptime",
      "connections": "Connections",
      "memory": "Memory",
      "singbox": "sing-box",
      "appliedRev": "Applied revision",
      "pendingRev": "Pending revision",
      "routing": "Open routing",
      "reissue": "Reissue install command",
      "delete": "Delete node",
      "deleteTitle": "Delete {{name}}?",
      "deleteBody": "Removes the node from the control plane.",
      "deleteConsequences": [
        "Nodes still used by a package or with an active boot session can’t be deleted.",
        "Uninstall the adapter on the host separately."
      ],
      "deleted": "Node deleted",
      "noHeartbeat": "No heartbeat received yet."
    },
    "edit": {
      "title": "Edit node",
      "saved": "Node saved",
      "address4": "IPv4 address",
      "address6": "IPv6 address",
      "transport": "Transport",
      "portInvalid": "Enter a port from 1 to 65535.",
      "addressCannotClear": "An address can be changed but not removed here. Enter a new address.",
      "nameRequired": "Enter a name.",
      "address4Invalid": "Enter an IPv4 address, like 203.0.113.10.",
      "address6Invalid": "Enter an IPv6 address, like 2001:db8::1.",
      "labelsReplaceName": "Shown with a protocol prefix. While region, provider or route labels are set, the node is listed by those labels instead.",
      "nameFromLabels": "Listed by its region, provider and route labels. Change the labels in metadata to rename it."
    },
    "create": {
      "title": "New standalone node",
      "submit": "Create node",
      "maybeCreatedTitle": "“{{name}}” may already have been created",
      "maybeCreatedBody": "The response was lost, and a new node with this name now exists. It is probably yours, but that can’t be proven, and its first install token was never shown (it may still be valid). Open it, check its details, revoke adapter tokens you don’t recognise, then issue an install command from there.",
      "openExisting": "Open node",
      "startNew": "Start a new node instead",
      "unknownTitle": "It's not known whether “{{name}}” was created",
      "unknownBody": "The last attempt didn't get an answer. Check again before creating it, so you don't end up with two nodes.",
      "unknownLookupFailed": "The last attempt didn't get an answer, and the node list couldn't be read either. Check again once the connection is back.",
      "checkAgain": "Check again",
      "unknownNotFoundYet": "No node with this name shows up yet. It may still be committing, so creating again could make a second one. Check again in a moment, or start a new node on purpose."
    },
    "bundleTitle": "Install command",
    "bundleBody": "Run this on the host. It prompts for the one-time adapter token.",
    "adapterToken": "Adapter token",
    "adapterConfig": "Adapter config",
    "disable": {
      "title": "Disable {{name}}?",
      "body": "The node stops accepting connections as soon as its adapter applies the change.",
      "consequences": [
        "Users connected through this node are disconnected.",
        "Subscriptions keep listing it, but it won’t carry traffic until you set it back to active."
      ],
      "confirm": "Disable node"
    },
    "tokens": {
      "rotateBody": "A new token is issued and the old one stops working immediately. The node's adapter can't fetch configuration or report traffic until you install the new token.",
      "rotateExpired": "This token has expired, so rotating it would give an already-expired token. Create a new token instead.",
      "revokeBody": "This token stops working immediately. If the node's adapter uses it, it can't fetch its configuration or report traffic until a new token is installed."
    },
    "uninstallTitle": "Clean up the node on its host",
    "uninstallBody": "The node’s adapter instance is still running on its host. Run this there to stop it and remove its config and state. Other nodes on the host keep running.",
    "bundleBodyOn": "Run this on {{server}}, the server the node was moved to, not on this one. It prompts for the one-time adapter token.",
    "installUnknown": "An install token may have been issued for {{name}}",
    "installUnknownBody": "The response was lost, so its secret can’t be shown. Before trying again, open {{name}} on the Nodes page and revoke adapter tokens you don’t recognise.",
    "deleteLeave": "A node delete is being checked, or its host cleanup command is still on screen. If you leave now it won’t be shown again. Leave anyway?",
    "unseenTokenTitle": "An adapter token may exist that was never shown",
    "unseenTokenBody": "A request for this node lost its response after it may have issued a token. Revoke any token below you don’t recognise; install commands for this node stay off until you confirm.",
    "unseenTokenDone": "I’ve checked the tokens",
    "unseenTokenBlocked": "Check this node’s adapter tokens first (Nodes page): a token may have been issued that was never shown.",
    "unseenTokenReissueOff": "Reissue is off: a token may have been issued that was never shown.",
    "reviewTokens": "Review tokens",
    "unseenTokenWaitList": "Waiting for an up-to-date token list before this can be confirmed.",
    "unseenMoveBlocked": "{{name}} moved, but its install command is on hold: a token may have been issued for it that was never shown. Check its adapter tokens first.",
    "getInstallCommand": "Get install command",
    "unseenTokenListFailed": "Couldn’t load the current token list, so this can’t be confirmed yet.",
    "reloadTokens": "Reload tokens",
    "drain": {
      "title": "Drain {{name}}?",
      "body": "The node is taken out of service as soon as this is saved.",
      "consequences": [
        "Its adapter can no longer fetch configuration, so later changes don’t reach it.",
        "It’s left out of users’ subscriptions until you set it back to active."
      ],
      "confirm": "Drain node"
    },
    "openGone": "That node no longer exists"
  },
  "groups": {
    "title": "Node groups",
    "external": {
      "title": "External nodes",
      "empty": "No external nodes in this group yet.",
      "pick": "Select external node",
      "add": "Add to group",
      "remove": "Remove",
      "added": "External node added to group",
      "removed": "External node removed from group"
    },
    "new": "New group",
    "empty": "No node groups yet",
    "emptyBody": "Packages grant access by node group. Create one to start building packages.",
    "members_one": "{{count}} node",
    "members_other": "{{count}} nodes",
    "manage": "Members",
    "form": {
      "createTitle": "New node group",
      "editTitle": "Edit node group",
      "name": "Name",
      "description": "Description"
    },
    "saved": "Group saved",
    "deleteTitle": "Delete {{name}}?",
    "deleteBody": "Groups still used by a package can’t be deleted.",
    "deleted": "Group deleted",
    "members": {
      "title": "Members of {{name}}",
      "body": "Each member has a credential domain and a billing rate. 2/1 bills twice the traffic.",
      "add": "Add nodes",
      "addTitle": "Add nodes",
      "search": "Search nodes",
      "selectAll": "Select all shown",
      "domain": "Credential domain",
      "rate": "Billing rate",
      "addSubmit_one": "Add {{count}} node",
      "addSubmit_other": "Add {{count}} nodes",
      "added_one": "Added {{count}} node",
      "added_other": "Added {{count}} nodes",
      "partial": "{{ok}} added, {{failed}} failed",
      "remove": "Remove",
      "removed": "Member removed",
      "updated": "Member updated",
      "empty": "No members yet",
      "noneAvailable": "Every node is already in this group.",
      "removeTitle": "Remove {{node}} from this group?",
      "removeBody": "Every package that uses {{group}} stops offering this node. Subscribers lose access to it at the next configuration sync.",
      "thisNode": "this node",
      "rateInvalid": "Use a rate of at least 1 / 1.",
      "allFailed_one": "Couldn’t add the node. See the reason below.",
      "allFailed_other": "Couldn’t add any of the {{count}} nodes. See the reasons below.",
      "maybeAdded": "May already have been added (the response was lost).",
      "relayBackend": "Backend",
      "maybeAddedBody": "The member list has been refreshed: nodes now listed as members were added."
    }
  },
  "routing": {
    "title": "Routing",
    "counts": {
      "globalVersion": "Version {{version}}",
      "noGlobal": "Not published",
      "nodesCustom": "{{count}} customized",
      "policies_one": "{{count}} policy",
      "policies_other": "{{count}} policies",
      "loading": "Counting…",
      "unavailable": "Count unavailable",
      "someUnavailable": "Some routing information couldn’t be loaded, so these counts may be incomplete.",
      "rejectLists_one": "{{count}} list",
      "rejectLists_other": "{{count}} lists",
      "nodesAccessControlled_one": "{{count}} node uses them",
      "nodesAccessControlled_other": "{{count}} nodes use them"
    },
    "open": "Open",
    "rules_one": "{{count}} rule",
    "rules_other": "{{count}} rules",
    "final": "Otherwise → {{outbound}}",
    "preflight": {
      "run": "Run preflight",
      "running": "Checking every target node…",
      "title": "Preflight",
      "passed": "Ready on {{ready}} of {{total}} nodes",
      "failed": "Blocked: fix the errors below",
      "stale": "Content changed since the last preflight. Run it again before saving.",
      "required": "Run preflight to enable publishing.",
      "node": "Node",
      "revision": "Revision {{from}} → {{to}}",
      "diff": "{{added}} added · {{removed}} removed",
      "finalChanged": "Fallback changes",
      "ruleSetChanged": "Rule sets change",
      "warnings": "Warnings",
      "errors": "Errors",
      "effective": "Effective route",
      "missingTags": "Missing outbounds: {{tags}}",
      "portable": "Usable everywhere: {{tags}}",
      "notEligible": "Not a target"
    },
    "global": {
      "title": "Global default",
      "editor": "Route",
      "publish": "Publish",
      "publishTitle": "Publish the global route?",
      "published": "Global route published",
      "version": "Version {{version}} · {{time}}",
      "invalid": "The route must be a JSON object with a final outbound.",
      "leaveUnsaved": "You have unsaved changes to the global route. Leave and discard them?",
      "publishBody_other": "This changes routing on {{count}} nodes as they pick up their next revision.",
      "publishBody_one": "This changes routing on {{count}} node as it picks up its next revision."
    },
    "nodes": {
      "title": "Node routing",
      "columns": {
        "node": "Node",
        "mode": "Mode",
        "final": "Default outbound",
        "status": "Status"
      },
      "inSync": "In sync",
      "pending": "Pending",
      "drift": "Drift",
      "noHeartbeat": "No heartbeat",
      "inheritedFinal": "inherited",
      "globalUnavailable": "Global default couldn't be loaded",
      "globalUnavailableBody": "Fallbacks for inheriting and overlay nodes show as unavailable until it loads.",
      "settings": "Settings"
    },
    "node": {
      "back": "Node routing",
      "tabs": {
        "default": "Default route",
        "users": "User overrides"
      },
      "mode": "Mode",
      "overlayNeedsGlobal": "Publish a global default first to use Add rules.",
      "route": "Node route",
      "dns": "DNS",
      "save": "Save node route",
      "saved": "Node route saved",
      "status": "Live status",
      "capability": "Per-user routing",
      "capable": "Supported ({{protocols}})",
      "notCapable": "Not supported by this node’s adapter",
      "appliedRev": "Applied",
      "pendingRev": "Pending",
      "drift": "Configuration drift detected",
      "contract": "Required outbounds",
      "available": "Available outbounds",
      "leaveUnsaved": "You have unsaved route changes. Leave and discard them?",
      "shape": {
        "notObject": "The route must be a JSON object.",
        "needsFinal": "Replace needs a non-empty \"final\" outbound.",
        "noFinal": "Remove \"final\": in overlay mode the fallback comes from the global default.",
        "needsRules": "Overlay needs at least one rule in \"rules\"."
      },
      "accessControl": {
        "title": "Access control",
        "manage": "Manage lists",
        "reject_from": "Reject connection from",
        "reject_to": "Reject connect to",
        "noLists": "No lists yet. Create one under Manage lists.",
        "missing": "Deleted list"
      },
      "globalReference": "Current global policy",
      "additionalRules": "Additional node rules"
    },
    "users": {
      "title": "User routing",
      "user": "User",
      "search": "Search users",
      "noPolicy": "No policy",
      "capability": "Capability",
      "policies": "Policies",
      "newPolicy": "New policy",
      "noPolicies": "This user follows node and global routing.",
      "scope": "Applies to",
      "node": "Node",
      "status": "Status",
      "protocol": "Protocol",
      "protocolHint": "Needed to check node support when enabling.",
      "outboundTags": "Outbound tags",
      "outboundTagsHint": "Comma-separated tags that must exist on the target nodes.",
      "route": "Route",
      "save": "Save policy",
      "saved": "Policy saved",
      "createTitle": "New routing policy",
      "editTitle": "Edit routing policy",
      "versions": "History",
      "version": "Version {{version}}",
      "rollback": "Restore as draft",
      "rollbackTitle": "Restore version {{version}}?",
      "rollbackBody": "Creates a new disabled draft from this version. Run preflight and enable it to make it live.",
      "rolledBack": "Version restored as a disabled draft",
      "delete": "Delete policy",
      "deleteTitle": "Delete this policy?",
      "deleteBody": "The user falls back to node and global routing.",
      "deleted": "Policy deleted",
      "enable": "Enable",
      "disable": "Disable",
      "trace": "Route trace",
      "unsupported": "Per-user routing works only on Hysteria2 and AnyTLS nodes with an adapter that reports user-routing.v1.",
      "inherited": "Inherited · all nodes",
      "versionsTruncated": "Showing the latest {{count}} versions.",
      "enableBlocked": "Preflight didn’t pass, so the policy stays off",
      "enableBlockedBody": "Review it in the editor, run preflight, then enable it.",
      "disableTitle": "Turn off this policy?",
      "disableBodyAll": "{{user}} goes back to the node defaults on every node right away.",
      "disableBodyNode": "{{user}} goes back to the default route on {{node}} right away.",
      "outboundTagsPlaceholder": "proxy, direct",
      "alreadyInState": "Already in that state",
      "rollbackTakesOffline": "This policy is live. The restored version starts disabled, so its routing stops applying on every node until you enable it again.",
      "nodeNotCapable": "{{protocol}} · can't take per-user routes",
      "deleteBodyAll": "Deletes {{user}}’s policy for every node; they fall back to node and global routing.",
      "deleteBodyNode": "Deletes {{user}}’s policy on {{node}}; on that node they fall back to its default and global routing.",
      "routeNeedsRules": "Add at least one rule or a final outbound: an empty route can’t be saved.",
      "gone": "This policy no longer exists"
    },
    "trace": {
      "match": "When",
      "any": "any traffic",
      "then": "then",
      "reject": "reject",
      "direct": "go direct",
      "route": "send to {{outbound}}",
      "ruleSet": "rule set {{tags}}",
      "privateIp": "private IP",
      "invalidShape": "This route can’t be previewed: rules must be a list of rule objects, and final, action and outbound must be text.",
      "actions": {
        "route": "route",
        "reject": "reject",
        "hijack_dns": "answer DNS locally",
        "sniff": "detect protocol",
        "resolve": "resolve domain",
        "route_options": "set route options",
        "bypass": "bypass",
        "unknown": "other action {{action}}"
      },
      "notPrivateIp": "public IP",
      "fields": {
        "domain": "domain",
        "domain_suffix": "domain suffix",
        "domain_keyword": "domain keyword",
        "domain_regex": "domain regex",
        "ip_cidr": "IP range",
        "source_ip_cidr": "source IP range",
        "port": "port",
        "port_range": "port range",
        "source_port": "source port",
        "source_port_range": "source port range",
        "protocol": "protocol",
        "network": "network",
        "clash_mode": "Clash mode",
        "override_address": "override address",
        "override_port": "override port",
        "network_strategy": "network strategy",
        "fallback_delay": "fallback delay",
        "udp_disable_domain_unmapping": "UDP domain unmapping off",
        "udp_connect": "UDP connect",
        "udp_timeout": "UDP timeout",
        "tls_fragment": "TLS fragment",
        "tls_fragment_fallback_delay": "TLS fragment fallback delay",
        "tls_record_fragment": "TLS record fragment",
        "tls_spoof": "TLS spoof",
        "tls_spoof_method": "TLS spoof method",
        "method": "method",
        "no_drop": "no drop",
        "sniffer": "sniffer",
        "timeout": "timeout",
        "server": "server",
        "strategy": "strategy",
        "disable_cache": "cache off",
        "disable_optimistic_cache": "optimistic cache off",
        "rewrite_ttl": "rewrite TTL",
        "client_subnet": "client subnet",
        "remove_client_subnet": "remove client subnet"
      }
    },
    "rejectLists": {
      "title": "Reject CIDR lists",
      "new": "New list",
      "empty": "No lists yet",
      "emptyBody": "Create a list of addresses, then select it on a node’s routing page.",
      "name": "Name",
      "description": "Description",
      "cidrs": "Addresses",
      "cidrsHint": "One IPv4 or IPv6 prefix or address per line ({{count}} of {{max}}). Saved lists are normalized and deduplicated.",
      "invalidLines_one": "{{count}} line isn’t a valid address or prefix: {{lines}}",
      "invalidLines_other": "{{count}} lines aren’t valid addresses or prefixes: {{lines}}",
      "tooMany": "A list holds at most {{max}} entries.",
      "tooLong": "Too long.",
      "entries_one": "{{count}} entry",
      "entries_other": "{{count}} entries",
      "usedBy_one": "used by {{count}} node",
      "usedBy_other": "used by {{count}} nodes",
      "usedByNodes": "Used by {{nodes}}. Saving gives these nodes a new configuration revision.",
      "unused": "No node uses this list yet.",
      "updated": "Updated {{when}}",
      "select": "Select a list to edit it.",
      "created": "List created",
      "saved": "Saved version {{version}}",
      "deleted": "Deleted {{name}}",
      "deleteTitle": "Delete {{name}}?",
      "deleteBody": "The list is removed for good.",
      "deleteConsequence": "A list still selected by a node can’t be deleted. Clear it on those nodes first.",
      "leaveUnsaved": "This list has unsaved changes. Leave the page and discard them?",
      "discardDraft": "Your edits to this list haven’t been saved.",
      "builtin": {
        "name": "All node IPs",
        "badge": "Built-in",
        "count_one": "{{count}} address right now",
        "count_other": "{{count}} addresses right now",
        "usedByNodes": "Used by {{nodes}}."
      }
    },
    "tabs": {
      "global": "Global policy",
      "users": "User policies",
      "nodes": "Node defaults",
      "access-control": "Access control"
    },
    "binding": {
      "title": "Add rules from rule sets",
      "ruleSet": "Rule set",
      "action": "Action",
      "selectRuleSet": "Select a rule set…",
      "selectAction": "Select an action…",
      "reject": "Reject traffic",
      "add": "Add rule",
      "remove": "Remove {{tag}} rule",
      "latest": "Follows latest resource",
      "empty": "No active rule sets"
    }
  },
  "resources": {
    "title": "External resources",
    "tabs": {
      "outbound": "Outbounds",
      "rule_set": "Rule sets",
      "subscriptions": "Subscriptions",
      "nodes": "External nodes"
    },
    "nodes": {
      "new": "New external node",
      "edit": "Edit external node",
      "empty": "No external nodes",
      "emptyBody": "Add a share link, then select the node in a node group.",
      "uri": "Share link",
      "uriHint": "Supports the share-link formats already accepted by external subscriptions. The original link is hidden after saving.",
      "uriKeep": "Leave empty to keep the current link.",
      "name": "Name",
      "server": "Server",
      "protocol": "Protocol",
      "status": "Status",
      "enabled": "Enabled",
      "disabled": "Disabled",
      "saved": "External node saved",
      "deleted": "External node deleted",
      "deleteTitle": "Delete {{name}}?",
      "deleteBody": "A node referenced by a group or subscriber cannot be deleted. Remove it from groups and refresh affected subscriptions first."
    },
    "new": "New resource",
    "newOutbound": "New outbound",
    "newRuleSet": "New rule set",
    "empty": "Nothing here yet",
    "emptyBody": "Resources are versioned, so routing policies can pin a version.",
    "select": "Select a resource to view and edit it.",
    "name": "Name",
    "tags": "Tags",
    "tagsHint": "Comma-separated.",
    "status": "Status",
    "definition": "Definition",
    "saveVersion": "Save new version",
    "created": "Resource created",
    "savedVersion": "Saved version {{version}}",
    "version": "Version {{version}}",
    "versions": "Versions",
    "filters": {
      "status": "Status"
    },
    "ext": {
      "new": "New subscription",
      "empty": "No external subscriptions",
      "emptyBody": "Import nodes from a third-party subscription link and distribute them through packages.",
      "createTitle": "New external subscription",
      "editTitle": "Edit external subscription",
      "name": "Name",
      "url": "Subscription URL",
      "urlHint": "Stored encrypted and never shown again.",
      "urlKeep": "Leave empty to keep the current URL ({{host}}).",
      "format": "Format",
      "formats": {
        "auto": "Detect",
        "uri": "URI list",
        "clash": "Clash",
        "surge": "Surge"
      },
      "filterMode": "Node filter",
      "filterModes": {
        "include": "Keep only",
        "exclude": "Drop"
      },
      "keywords": "Keywords",
      "keywordsHint": "Comma-separated. Leave empty to import everything.",
      "prefix": "Name prefix",
      "interval": "Sync every",
      "intervalMinutes": "{{count}} min",
      "enabled": "Sync automatically",
      "syncNow": "Sync now",
      "synced": "Sync started",
      "nodes": "Imported nodes",
      "noNodes": "No nodes imported yet.",
      "lastSync": "Last sync",
      "nextSync": "Next sync",
      "never": "Never",
      "saved": "Subscription saved",
      "deleteTitle": "Delete {{name}}?",
      "deleteBody": "Imported nodes are removed. Packages that use it lose these nodes.",
      "deleted": "Subscription deleted",
      "server": "Server",
      "nodesTruncated": "Showing {{shown}} of {{total}} nodes.",
      "intervalInvalid": "Enter whole minutes from 1 to 10080 (7 days).",
      "keywordsInvalid": "Use at most 50 keywords, each up to 80 bytes (about 26 Chinese characters).",
      "tooLong": "Too long: keep it under 120 bytes (about 40 Chinese characters).",
      "urlRejected": "The server refused this URL. Use a public http(s) address without credentials.",
      "urlProblem": {
        "tooLong": "This URL is too long (4096 bytes at most).",
        "invalid": "Enter a full http:// or https:// URL.",
        "credentials": "Remove the user name or password before the host (put tokens in the path or query instead).",
        "private": "This address is local or private. Use a public address.",
        "hostTooLong": "The host name is too long (255 bytes at most)."
      }
    },
    "versionsTruncated": "Showing the latest {{count}} versions.",
    "discardDraft": "You have unsaved changes to this resource. Discard them?",
    "leaveUnsaved": "You have unsaved resource changes. Leave and discard them?",
    "goneFromView": "No longer in this list",
    "goneFromViewBody": "Its status changed (for example someone archived it), so it no longer matches this filter. Your draft is kept; saving still updates this resource.",
    "definitionEmpty": "Add at least one entry: the API doesn’t accept an empty definition.",
    "definitionShape": "Use a JSON object, or a list of objects."
  },
  "auditPage": {
    "title": "Audit log",
    "filters": {
      "action": "Action",
      "resource": "Resource",
      "outcome": "Outcome",
      "system": "Show system events"
    },
    "actionPlaceholder": "Any action",
    "empty": "No matching events",
    "emptyBody": "Try different filters.",
    "columns": {
      "time": "Time",
      "event": "Event",
      "resource": "Object",
      "actor": "Actor",
      "ip": "IP",
      "outcome": "Result"
    },
    "detail": {
      "title": "Event details",
      "resource": "Object",
      "actor": "Actor",
      "outcome": "Result",
      "ip": "IP address",
      "requestId": "Request ID",
      "changes": "Changes",
      "snapshot": "Object at the time",
      "context": "More information",
      "none": "Nothing else was recorded.",
      "raw": "Raw record",
      "field": "Field",
      "before": "Before",
      "after": "After",
      "auditId": "Record ID",
      "action": "Action code"
    },
    "emptySystemHidden": "Only system entries so far",
    "emptySystemHiddenBody": "Routine system entries are hidden. Show them, or load more to look further back.",
    "showSystem": "Show system entries",
    "emptyNone": "No activity yet",
    "emptyNoneBody": "Actions taken in the console will appear here."
  }
}
